import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=0a8cbab9&scoped=true&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"
import style0 from "./MainPage.vue?vue&type=style&index=0&id=0a8cbab9&prod&scoped=true&lang=css&"
import style1 from "./MainPage.vue?vue&type=style&index=1&id=0a8cbab9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8cbab9",
  null
  
)

export default component.exports